import React, { useMemo } from 'react'
import './TableItem.scss'

const TableItem = ({ data }) => {
  const {
    code = '',
    id = '',
    comments = '',
    time = '',
    location = '',
    driver = '',
    picker = '',
    picking = '',
    delivery = '',
    van = '',
    status = '',
    payment = '',
    paid = 0,
    order = {},
  } = data

  // Извлекаем текст статуса
  const statusText = typeof status === 'object' && status !== null ? status.name : status

  const total = useMemo(() => {
    if (order?.items?.length) {
      const itemsTotal = order.items.reduce((acc, item) => {
        const price = parseFloat(item.marketPriceCP) || 0
        const quantity = item.quantity || 1
        return acc + price * quantity
      }, 0)
      const deliveryPrice = parseFloat(order.deliveryPrice) || 0
      return itemsTotal + deliveryPrice
    }
    return 0
  }, [order])

  const totalDebt = useMemo(() => {
    return total - (parseFloat(paid) || 0)
  }, [total, paid])

  return (
    <div className='table-item'>
      <div className='cell code'>{code}</div>
      <div className='cell order'>{id}</div>
      <div className='cell comments'>{comments}</div>
      <div className='cell time'>{time}</div>
      <div className='cell location'>{location}</div>
      <div className='cell driver'>{driver ? <img src={driver} alt='driver' /> : null}</div>
      <div className='cell picker'>{picker ? <img src={picker} alt='picker' /> : null}</div>
      <div className='cell picking'>{picking}</div>
      <div className='cell delivery'>{delivery}</div>
      <div className='cell van'>
        <span className='tag green'>{van}</span>
      </div>
      <div className='cell'>
        <span className={`tag ${typeof statusText === 'string' ? statusText.toLowerCase() : ''}`}>{statusText || ''}</span>
      </div>
      <div className='cell payment'>{payment}</div>
      <div className='cell debt'>{totalDebt.toFixed(2)}</div>
      <div className='cell paid'>{parseFloat(paid).toFixed(2)}</div>
      <div className='cell total'>{total.toFixed(2)}</div>
    </div>
  )
}

export default TableItem
